import axios from "axios";
import {ENDPOINT_IMPORT, ENDPOINT_REFERENCES_FORMATIONS, ENDPOINT_SEARCH} from "../constants/endpoints";
import AlertStore from '@/stores/AlertStore'

let store = {
  debug: true,

  search(pageIndex, pageSize, sortOptions) {
    let recherche = [];
    let url = `${ENDPOINT_REFERENCES_FORMATIONS + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }
    return axios.post(url, recherche);
  },

  importExcel(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(ENDPOINT_REFERENCES_FORMATIONS + ENDPOINT_IMPORT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  getImports() {
    return axios.get(ENDPOINT_REFERENCES_FORMATIONS + ENDPOINT_IMPORT);
  },
  deleteImport(id) {
    return axios
        .delete(ENDPOINT_REFERENCES_FORMATIONS + ENDPOINT_IMPORT + '/' + id)
        .then(() => {
          AlertStore.pushSuccess('Ligne d\'historique supprimée avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
};

export default store;
